import React from 'react';

import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import green from '@material-ui/core/colors/green';
import Typography from "@material-ui/core/Typography";
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import SegmentSpacer from "./SegmentSpacer";

// Icons
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowLeftIcon from'@material-ui/icons/KeyboardArrowLeft';
import {CircularProgress} from "@material-ui/core";
import Loading from "./Loading";

// import Personal from "../views/Personal";
// import EarlierWill from "../views/EarlierWill";
// import UskifteOrMutualWill from "../views/UskifteOrMutualWill";
// import WillType from "../views/WillType";
// import T1Children from "../views/T1Children";
// import T2Children from "../views/T2Children";
// import ChildrenInfoPage from "../views/ChildrenInfoPage";
// import ShareItems from "../views/ShareItems";
// import MutualWill from "../views/MutualWill";
// import SepProp from "../views/SepProp";
// import OtherQuestions from "../views/OtherQuestions";
// import FinalInfo from "../views/FinalInfo";
// import SignOptions from "../views/SignOptions";

const Personal = React.lazy(() => import('../views/Personal'));
const EarlierWill = React.lazy(() => import('../views/EarlierWill'));
const UskifteOrMutualWill = React.lazy(() => import('../views/UskifteOrMutualWill'));
const WillType = React.lazy(() => import('../views/WillType'));
const T1Children = React.lazy(() => import('../views/T1Children'));
const T2Children = React.lazy(() => import('../views/T2Children'));
const ChildrenInfoPage = React.lazy(() => import('../views/ChildrenInfoPage'));
const ShareItems = React.lazy(() => import('../views/ShareItems'));
const MutualWill = React.lazy(() => import('../views/MutualWill'));
const SepProp = React.lazy(() => import('../views/SepProp'));
const OtherQuestions = React.lazy(() => import('../views/OtherQuestions'));
const FinalInfo = React.lazy(() => import('../views/FinalInfo'));
const SignOptions = React.lazy(() => import('../views/SignOptions'));


const pages = currentData => ([
    // {
    //     pageName: 'intro',
    //     heading: 'Testament',
    //     nextPage: 'personal',
    //     prevPage: null
    // },
    {
        pageName: 'personal',
        heading: 'Din informasjon',
        nextPage: 'earlierWill',
        prevPage: 'intro'
    },
    {
        pageName: 'earlierWill',
        heading: 'Tidligere testament',
        nextPage: 'uskifteOrMutualWill',
        prevPage: 'personal'
    },
    {
        pageName: 'uskifteOrMutualWill',
        heading: 'Uskifte eller arv fra gjensidig testament',
        nextPage: 'willType',
        prevPage: 'earlierWill'
    },
    {
        pageName: 'willType',
        heading: 'Velg ett av disse alternativene',
        nextPage: 't1Children',
        prevPage: 'uskifteOrMutualWill'
    },
    {
        pageName: 't1Children',
        heading: currentData.willType.value === 'alone' ? 'Har du barn?' : `Har testator 1 (${currentData.personal.name}) barn?`,
        nextPage: (() => {
            if (currentData.willType.value === 'alone' && currentData.t1Children.hasChildren === 'no'){return 'shareItems';}
            if (currentData.willType.value === 'alone' && currentData.t1Children.hasChildren === 'yes'){return 'childrenInfoPage';}
            return 't2Children';
        })(),
        prevPage: 'willType'
    },
    {
        pageName: 't2Children',
        heading: `Har testator 2 (${currentData.willType.t2Personal.name}) barn?`,
        nextPage: (() => {
            if (currentData.t1Children.hasChildren === 'yes' || currentData.t2Children.hasChildren === 'yes'){return 'childrenInfoPage';}
            return 'mutualWill';
        })(),
        prevPage: 't1Children'
    },
    {
        pageName: 'childrenInfoPage',
        heading: 'Informasjon til deg som har barn og skal opprette testament',
        nextPage: (() => {
            if (currentData.willType.value === 'alone'){return 'shareItems'}
            return 'mutualWill'
        })(),
        prevPage: (() => {
            if (currentData.willType.value === 'alone'){return 't1Children'}
            return 't2Children';
        })()
    },
    {
        pageName: 'mutualWill',
        heading: 'Gjensidig Testament',
        nextPage: 'shareItems',
        prevPage: (() => {
            if (currentData.willType.value === 'alone' && currentData.t1Children.hasChildren === 'no'){return 't1Children';}
            if (currentData.willType.value === 'alone' && currentData.t1Children.hasChildren === 'yes'){return 'childrenInfoPage';}
            if (currentData.t1Children.hasChildren === 'no' && currentData.t2Children.hasChildren === 'no'){return 't2Children';}
            return 'childrenInfoPage';
        })()
    },
    {
        pageName: 'shareItems',
        heading: currentData.willType.value === 'alone' ? 'Arvinger' : 'Andre arvinger',
        nextPage: 'sepProp',
        prevPage: (() => {
            if (currentData.willType.value === 'alone' && currentData.t1Children.hasChildren === 'no'){return 't1Children';}
            if (currentData.willType.value === 'alone' && currentData.t1Children.hasChildren === 'yes'){return 'childrenInfoPage';}
            return 'mutualWill';
        })()
    },
    {
        pageName: 'sepProp',
        heading: `Vil ${currentData.willType.value === 'alone' ? 'du' : 'dere'} at all arv skal være mottakerens særeie?`,
        nextPage: 'otherQuestions',
        prevPage: 'shareItems'
    },
    {
        pageName: 'otherQuestions',
        heading: 'Andre spørsmål, kommentarer eller opplysninger',
        nextPage: 'finalInfo',
        prevPage: 'sepProp'
    },
    {
        pageName: 'finalInfo',
        heading: 'Informasjon',
        nextPage: 'signOptions',
        prevPage: 'otherQuestions'
    },
    {
        pageName: 'signOptions',
        heading: `Vil ${currentData.willType.value === 'alone' ? 'du' : 'dere'} underskrive testamentet på advokatkontor i Oslo?`,
        nextPage: 'payment',
        prevPage: 'finalInfo'
    }
]);

class FormController extends React.Component{
    state = {
        pageIndex: 0,
        data: {
            // intro: {
            //     valid: true
            // },
            personal: {
                name: null,
                dateOfBirth: null,
                address: null,
                zip: null,
                city: null,
                tlf: null,
                email: null,
                confirmEmail: null,
                valid: false
            },
            earlierWill: {
                value: null,
                valid: false
            },
            uskifteOrMutualWill: {
                inUskifte: null,
                hasInheritedFromMutualWill: null,
                valid: false
            },
            willType: {
                value: null,
                valid: false,
                t2Personal: {
                    name: null,
                    dateOfBirth: null,
                    address: null,
                    zip: null,
                    city: null,
                    tlf: null,
                    email: null,
                    confirmEmail: null,
                }
            },
            t1Children: {
                hasChildren: null,
                childCount: null,
                children: null,
                valid: false,
            },
            t2Children: {
                hasChildren: null,
                childCount: null,
                children: null,
                valid: false,
            },
            childrenInfoPage: {
                valid: true
            },
            mutualWill: {
                value: null,
                inheritanceDescription: null,
                valid: false
            },
            shareItems: {
                value: null,
                valid: true,
                heirs: [
                    {inheritanceDescription: null, heirIsOrganization: null, heirName: null, heirDateOfBirth: null, heirAddress: null, heirZip: null, heirCity: null}
                ]
            },
            sepProp: {
                value: null,
                valid: false
            },
            otherQuestions: {
                text: null,
                valid: true
            },
            finalInfo: {
                valid: true
            },
            signOptions: {
                value: null,
                termsAccepted: false,
                regretAccepted: false,
                valid: false
            },
            payment: {
                valid: false
            }
        }
    };

    setData = (pageName, value) => {
        this.setState(pendingState => {
            return {
                ...pendingState,
                data: {
                    ...pendingState.data,
                    [pageName]: value
                }
            }
        }, () => {
            // console.log(this.state.data);
        });
    };

    nextPage = () => {
        if (!this.navigationEnabled){return;}

        if (this.state.data[pages(this.state.data)[this.state.pageIndex].pageName].valid){
            const pageData = pages(this.state.data);
            const oldPageIndex = this.state.pageIndex;
            const newPageName = pageData[oldPageIndex].nextPage;

            let newPageIndex = 0;
            for (let page of pageData){
                if (page.pageName === newPageName){break;}
                newPageIndex += 1;
            }

            this.onNavigation(newPageName);
            this.setState({pageIndex: newPageIndex});
        }
    };

    prevPage = () => {
        if (!this.navigationEnabled){return;}

        if (this.state.pageIndex === 0){return;}

        const pageData = pages(this.state.data);
        const oldPageIndex = this.state.pageIndex;
        const newPageName = pageData[oldPageIndex].prevPage;

        let newPageIndex = 0;
        for (let page of pageData){
            if (page.pageName === newPageName){break;}
            newPageIndex += 1;
        }

        console.log(oldPageIndex, newPageName, newPageIndex);

        this.onNavigation(newPageName);
        this.setState({pageIndex: newPageIndex});
    };

    onNavigation = pageName => {
        // Scroll to header on navigate
        window.location.href = "#";
        window.location.href = "#will-module";

        const ga = window.ga;
        try {
            ga('send', {hitType: 'pageview', page: 'testamentModul_' + pageName});
        } catch (e) {
            console.error(e);
        }
    };

    navigationEnabled = true;

    disableNavigation = () => {
        this.navigationEnabled = false;
    };

    enableNavigation = () => {
        this.navigationEnabled = true;
    };

    render(){
        const { classes } = this.props;

        let pageComponent;
        switch (this.state.pageIndex) {
            // case 0:
            //     pageComponent = <Intro data={this.state.data} setData={this.setData}/>;
            //     break;
            case 0:
                pageComponent = <Personal data={this.state.data} setData={this.setData}/>;
                break;
            case 1:
                pageComponent = <EarlierWill data={this.state.data} setData={this.setData}/>;
                break;
            case 2:
                pageComponent = <UskifteOrMutualWill data={this.state.data} setData={this.setData}/>;
                break;
            case 3:
                pageComponent = <WillType data={this.state.data} setData={this.setData}/>;
                break;
            case 4:
                pageComponent = <T1Children data={this.state.data} setData={this.setData}/>;
                break;
            case 5:
                pageComponent = <T2Children data={this.state.data} setData={this.setData}/>;
                break;
            case 6:
                pageComponent = <ChildrenInfoPage/>;
                break;
            case 7:
                pageComponent = <MutualWill data={this.state.data} setData={this.setData}/>;
                break;
            case 8:
                pageComponent = <ShareItems data={this.state.data} setData={this.setData}/>;
                break;
            case 9:
                pageComponent = <SepProp data={this.state.data} setData={this.setData}/>;
                break;
            case 10:
                pageComponent = <OtherQuestions data={this.state.data} setData={this.setData}/>;
                break;
            case 11:
                pageComponent = <FinalInfo/>;
                break;
            case 12:
                pageComponent = <SignOptions
                    data={this.state.data}
                    setData={this.setData}
                    disableNavigation={this.disableNavigation}
                    enableNavigation={this.enableNavigation}
                />;
                break;
            default:
                throw new Error('No component for this page index');
        }

        const pgs = pages(this.state.data);
        const page = pgs[this.state.pageIndex];

        return(
            <div className={classes.wrapper}>
                <Paper className={classes.form}>
                    <Typography variant={'h3'} id={'willFormHeader'} gutterBottom>{ page.heading }</Typography>
                    <div className={classes.gutter}/>
                    <React.Suspense fallback={<Loading/>}>
                        { pageComponent }
                    </React.Suspense>
                    <div className={classes.gutter}/>
                    <SegmentSpacer/>
                    <Grid container justify={'space-between'}>
                        <Grid item>{ this.state.pageIndex > 0 ? <Button variant={'contained'} onClick={this.prevPage}><KeyboardArrowLeftIcon/>Tilbake</Button> : null}</Grid>
                        <Grid item>{ this.state.pageIndex < pgs.length - 1 ? <Button variant={"contained"} className={classes.nextButton} onClick={this.nextPage} disabled={!this.state.data[pgs[this.state.pageIndex].pageName].valid}>Neste <KeyboardArrowRightIcon/></Button> : null}</Grid>
                    </Grid>
                </Paper>
            </div>
        )
    }
}

const styles = theme => ({
    wrapper: {
        width: '100%',
        textAlign: 'center',
        display: 'block',
        [theme.breakpoints.down('sm')]: {
            width: '100vw',
            margin: '0 calc(50% - 50vw)'
        }
    },
    form: {
        maxWidth: '100%',
        width: '60rem',
        backgroundColor: 'transparent', //grey['100'],
        borderWidth: '0 2px',
        borderStyle: 'dotted',
        borderColor: 'rgba(0,0,0,0.87)',
        padding: '1rem',
        textAlign: 'left',
        [theme.breakpoints.up('md')]: {
            padding: '1rem'
        },
        borderRadius: '0',
        boxShadow: 'none',
        [theme.breakpoints.down('sm')]: {
            borderWidth: '0'
        },
        boxSizing: 'border-box'
    },
    gutter: {
        width: '100%',
        height: '1.5rem'
    },
    nextButton: {
        backgroundColor: green['500'],
        color: theme.palette.getContrastText(green['500']),
        '&:hover': {
            backgroundColor: green['300']
        }
    }
});

export default withStyles(styles)(FormController);